<template>
 <div class="container">
        <div class="row">
            <div class="col">
              <h2 class="VIDEOS">PROYECTS</span></h2>
            </div>
        </div>
        <div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" role="listbox">
                <div class="carousel-item active " style="background-image: url('/static/proyectos/luziabk.png')" data-parallax="scroll">
                    <div class="slyder1">
                        <img src="/static/proyectos/luziayilmer.png" alt="" class="imageProyect ">
                    </div>
                    <div class="slyder2">
                        <div class="infoProyect">
                            <h2>CIRQUE DU SOLEIL</h2>
                            <h3>2015 - Present</h3>
                            <p>Luzia, written and directed by Daniele Frinzi Pasca. A show based on Mexico with traditional elements and with Latin American sounds and colors all exposed in the contemporary world. A magical and surreal creation of Cirque du Soleil uniting artist of several part of the world.</p>
                            <a href="https://www.cirquedusoleil.com/es" target="_blank">
							<img src="../assets/proyectos/cirquelogo.png"  alt="Cirque Du Soleil" class="logoProyect" >
						</a>
                            <a href="https://www.cirquedusoleil.com/es/luzia" target="_blank">
							<img src="../assets/proyectos/cirquelogoLuzia.jpg"  alt="Cirque Du Soleil luzia" class="logoProyect" >
						</a>
                        </div>
                    </div>
                </div>
                <div class="carousel-item" style="background-image: url('/static/proyectos/colors1bk.png')" data-parallax="scroll">
                    <div class="slyder1">
                        <img src="../assets/proyectos/colorsportada.png" alt="" class="imageProyect ">
                    </div>
                    <div class="slyder2">
                        <div class="infoProyect">
                            <h2>Colors in My Mind</h2>
                            <h3>2018</h3>
                            <p>An album elaborated with simple and sincere ideas with the intention of creating, of being and reaching where space allows us to take the sounds that are born from what we are, being music the means to transport and the voice to express ourselves. Recorded in New York on October 2017 and will be launched during the first trimester of 2018.</p>

                            <a href="https://yilmervivas.bandcamp.com/" target="_blank">
                            <img src="../assets/bandcamp.png"  alt="Yilmer Bandcamp" class="" >
                            </a>

                            <a href="https://store.cdbaby.com/cd/yilmervivas" target="_blank">
                            <img src="../assets/cdbaby.png"  alt="CD Baby in My Mind" class="" >
                            </a>

                            <a href="https://cusica.com/album/899" target="_blank">
                              <img src="../assets/cusica.png"  alt="Yilmer Cusica" class="" >
                            </a>



                        </div>
                    </div>
                </div>
                <div class="carousel-item" style="background-image: url('/static/proyectos/sonartesbk.png')" data-parallax="scroll">
                    <div class="slyder1">
                        <img src="../assets/proyectos/sonartes.png" alt="" class="imageProyect ">
                    </div>
                    <div class="slyder2">
                        <div class="infoProyect">
                            <h2>Soñartes </h2>
                            <h3>2017</h3>
                            <p>This project was born from the union of common thoughts to help and encourage talented children and young ones of low economical resources that have the ability to develop themselves and grow in the world of arts; from music to cinema to theater, circus, dance, painting, crafts, photography ect.</p>

                            <a href="https://open.spotify.com/album/3Wux9Ldv9kr1OUjoGyrHcM" target="_blank">
                            <img src="../assets/spotify.png"  alt="Spotify" class="" >
                            </a>

                            <a href="https://store.cdbaby.com/cd/sonartesvenezuela" target="_blank">
                            <img src="../assets/cdbaby.png"  alt="CD Baby" class="" >
                            </a>

                        </div>
                    </div>
                </div>
                <a class="carousel-control-next" id="nextbtn"  role="button" data-slide="next">
			    <span class="carousel-control-next-icon" aria-hidden="true"></span>
			    <span class="sr-only">Next</span>
			  </a>
            </div>
        </div>
    </div>

</template>

<script>
export default {
  name: 'name',
  data() {
    return {
     
    }
  }
}

</script>
<style scoped="">
    
    .container {
      margin-top: 100px;
    }

    .VIDEOS {
      font-family: 'Open Sans', sans-serif;
      font-size: 35px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: -0.9px;
      text-align: left;
      color: rgb(0, 0, 0);
      color: var(--black);
      margin-bottom: 20px;
      margin-top: 30px;
    }

    .carousel-item {
        height: 450px;
        object-fit: contain;
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .carousel-item .imageProyect {
        object-fit: contain;
        width: 40%;
        height: 60%;
        z-index: 2;
        position: absolute;
        left: 8%;
        top: 15%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        -moz-transition: all 0.3s;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
    }

    .carousel-item .imageProyect:hover {
        -moz-transform: scale(1.1);
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .carousel-item .infoProyect {
        background: #ffffff;
        margin-bottom: 10%;
        margin-right: 2%;
        z-index: 1;
        position: absolute;
        left: 36%;
        top: 20%;
        padding-left: 14%;
        padding-right: 3%;
        padding-bottom: 10px;
        width: 55%;
    }

    .carousel-item h2 {
        margin-top: 4%;
        font-weight: bold;
        color: #6EBAD0;
    }

    .carousel-item h3 {
        margin-top: 2%;
        font-weight: bold;
        font-size: 16px;
        color: #424242;
    }

    .carousel-item p {
        margin-top: 6%;
        font-size: 14px;

        margin-bottom: 5%;
    }

    .carousel-item .logoProyect {
        margin-bottom: 10px;
        height: 42px;
        width: 65px;
        object-fit: contain;
    }

    .carousel-control-next-icon{
        cursor:pointer;
    }


    @media (max-width: 576px) {
        .carousel-item .imageProyect {
            height: 65%;
            width: 75%;
            z-index: 2;
            position: absolute;
            left: 10%;
            top: 0%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: 50% 50%;
        }

        .carousel-item .infoProyect {
            background: #ffffff;
            margin-bottom: 10%;
            margin-right: 2%;
            z-index: 1;
            position: absolute;
            left: 10%;
            top: 58%;
            padding-left: 8%;
            width: 80%;
        }

        .carousel-item p {
            display: none;
        }
    }


    @media (max-width: 767.98px) {
        .carousel-item p {
            font-size: 12px;
        }
    }


    .carousel-control-next-icon {
        background-image: url(../assets/proyectos/next@3x.png);
        height: 50px;
        width: 50px;

    }

    .carousel-control-next {
        opacity: 1.0 !important;
    }

    .carousel-inner>.item {
        position: relative;
        display: none;
        -webkit-transition: 0.6s ease-in-out left;
        -moz-transition: 0.6s ease-in-out left;
        -o-transition: 0.6s ease-in-out left;
        transition: 0.6s ease-in-out left;
    }
</style>



// WEBPACK FOOTER //
// src/components/YilmerProjects.vue